import 'core-js/stable' // For IE 11 support
import React from 'react'
import ReactDOM from 'react-dom'
import reportWebVitals from './reportWebVitals'

import App from './App'
import { DataContextProvider, SessionContextProvider } from './contexts'

ReactDOM.render(
    <React.StrictMode>
        <SessionContextProvider>
            <DataContextProvider>
                <App />
            </DataContextProvider>
        </SessionContextProvider>
    </React.StrictMode>,
    document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
